export enum FilterConstants {
  bigGem = 'Big Gem',
  smallGem = 'Small Gem',
  base = 'Base',
  rim = 'Rim',
}
